import { defineMessages } from "react-intl";

export const Common = defineMessages({
    Cancel: {
        id: "Shared.Common.Cancel",
        defaultMessage: "Cancel",
    }
} as const);